import { render } from "./TextButtonElement.vue?vue&type=template&id=51615d80&scoped=true"
import script from "./TextButtonElement.vue?vue&type=script&lang=js"
export * from "./TextButtonElement.vue?vue&type=script&lang=js"

import "./TextButtonElement.vue?vue&type=style&index=0&id=51615d80&scoped=true&lang=css"

import exportComponent from "../../../../peelochat-dashboard/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-51615d80"]])

export default __exports__